module.exports = __webpack_public_path__ + "img/slide4.a27d210a.png";